<template>
  <div class="layout-category-page">
    <div class="container">
      <div class="header">
        <div class="great-title">
          <slot name="title"></slot>
          <div class="filters-button" @click="opened = !opened">
            <img v-if="!opened" class="filters-button" src="@/assets/icons/filters.svg" alt="" />
            <img v-else class="filters-button" src="@/assets/icons/close.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="container" :class="[{ layout: $slots.filters }]">
      <div class="products">
        <slot></slot>
      </div>
      <div v-if="$slots.filters" class="filter-wrapper">
        <div class="filters" :class="[{ opened }]">
          <slot name="filters"></slot>
        </div>
        <ui-button v-if="openedFilters" class="more" @click="opened = !opened"
          ><span v-if="!opened">Show more</span><span v-else>Close</span></ui-button
        >
        <div class="show-more">
          Reset Filters
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    openedFilters: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      opened: false
    }
  },
  mounted() {
    if (this.openedFilters) {
      const filters = this.$el.querySelectorAll('.filters > *')
      filters.forEach((filter, index) => {
        index + 1 > this.openedFilters ? filter.classList.add('hidden') : ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-category-page {
  padding-bottom: 5em;
}
.layout {
  display: grid;
  grid-template-columns: auto 16em;
  grid-gap: 8.75em;
  align-items: flex-start;
  position: relative;
  .products {
    grid-template-columns: repeat(3, 1fr);
  }
}
.products {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 6em 1.5em;
}
.header {
  margin-bottom: 1em;
}
.filters {
  // position: sticky;
  position: relative;
  &.opened {
    & > *.hidden {
      display: block;
    }
  }
  // top: 7em;
  & > * {
    &.hidden {
      display: none;
    }
    &:not(:last-child) {
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);
      margin-bottom: 1.5em;
      padding-bottom: 1.5em;
    }
  }
}
.close {
  display: none;
}
.filters-button {
  display: none;
}
.show-more {
  cursor: pointer;
  text-decoration: underline;
  margin-top: 1em;
}
.more {
  margin-top: 1em;
}
@media screen and (max-width: 767px) {
  .layout {
    display: block;
    .products {
      // display: block;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .filters {
    position: absolute;
    width: 100%;
    background: #fff;
    top: 0;
    padding: 3em 2em;
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transition: 0.5s;
    transform: translate(0, 2em);
    &.opened {
      transform: translate(0, 0);
      opacity: 1;
      visibility: visible;
    }
  }
  .close {
    display: flex;
    justify-content: flex-end;
  }
  .filters-button {
    display: block;
  }
  .great-title {
    display: flex;
    // align-items: center;
    justify-content: space-between;
  }
}
</style>
